import { Component, OnInit, HostBinding, Inject, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';

import { NgxPermissionsService, NgxPermissionsObject } from 'ngx-permissions';
import { Constants } from './constants';
import { ThemesService } from '@projects/shared/src/app/features/setting/services/themes.service';
import { Logger } from './core/logger.service';
import { DOCUMENT } from '@angular/common';
const log = new Logger('Bootstrap');
interface City {
  name: string;
  code: string;
  inactive: boolean;
}
@Component({
  selector: 'app-bootstrap',
  template: `
    <!-- <div class="theme-tabs-wrapper" style="z-index: 999;">
      <ng-container *ngFor="let theme of themeService.themes">
        <button
          class="theme-tabs"
          [ngClass]="{ 'theme-tabs--active': theme.isActive }"
          [attr.data-tabs]="theme.cssClass"
          (click)="themeService.onThemeChange(theme.tab)"
        >
          <span>{{ themeService.Theme[theme.tab] }}</span>
          <input
            class="topbar"
            type="color"
            data-id="color-picker-tabs"
            name="Backgrounds"
            value="#fa0060"
            (change)="themeService.onCustomColorChange($event.target!)"
            *ngIf="theme.tab === themeService.Theme.CUSTOM"
          />
        </button>
      </ng-container>
    </div> -->
    <ng-container>
      <app-loader></app-loader>
      <ng-container *ngIf="isAuth(); else guest">
        <app-root></app-root>
      </ng-container>
      <ng-template #guest>
        <router-outlet></router-outlet>
      </ng-template>
    </ng-container>
  `,
  styles: [
    `
      input[type='color'].topbar {
        -webkit-appearance: none;
        border: none;
        width: 32px;
        height: 16px;
        margin-left: 10px;
      }
      input[type='color'].topbar::-webkit-color-swatch-wrapper {
        padding: 0;
      }
      input[type='color'].topbar::-webkit-color-swatch {
        border: none;
      }
    `,
  ],
})
export class BootstrapComponent implements OnInit {
  @HostBinding('class') get themeClass() {
    const newThemeClass = this.themeService.selectedTheme.cssClass;
    this.renderer.setAttribute(this.document.body, 'class', 'revised-layout ' + newThemeClass);

    return newThemeClass;
  }
  @HostBinding('style') get themeCustomStyle() {
    const customStyles =
      this.themeService.selectedTheme.tab === this.themeService.Theme.CUSTOM ? this.themeService.getCustomStyles() : '';

    this.renderer.setAttribute(
      this.document.body,
      'style',
      customStyles !== '' ? this.themeService.getCustomStylesAsString() : ''
    );

    return customStyles;
  }

  permissions!: NgxPermissionsObject;

  constructor(
    private router: Router,
    public authService: AuthenticationService,
    public ngxPermission: NgxPermissionsService,
    public themeService: ThemesService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    if (!this.authService.isAuthenticated()) {
      let isIdleTimeout = JSON.parse(localStorage.getItem('isIdleTimeout') || 'null');
      let isUserReloggedIn = JSON.parse(localStorage.getItem('isUserReloggedIn') || 'null');
      if (isIdleTimeout && isIdleTimeout == true) {
        localStorage.removeItem('isIdleTimeout');
        this.router.navigate(['idle-timeout']);
      } else if (isUserReloggedIn && isUserReloggedIn == true) {
        localStorage.removeItem('isUserReloggedIn');
        this.router.navigate(['post-logout']);
      } else {
        if (location.pathname.includes('signin-callback')) {
        } else if (
          !(
            this.authService.isNoAuthUrl()
            // location.pathname.includes('resetpassword') ||
            // location.pathname.includes('forgotpassword') ||
            // location.pathname.includes('sso') ||
            // location.pathname.includes('idle-timeout') ||
            // location.pathname.includes('session-message') ||
            // location.pathname.includes('signout-message') ||
            // location.pathname.includes('code-verification') ||
            // location.pathname.includes('set-password') ||
            // location.pathname.includes('recovery-code') ||
            // location.pathname.includes('recovery-code-verification') ||
            // location.pathname.includes('post-logout')
          )
        ) {
          this.router.navigate(['login']);
        }
      }
    } else {
      this.authService.isLoggedIn = true;
    }
    // router.events.subscribe((event: Event) => {
    //   if (event instanceof NavigationEnd) {
    //     if (event.url === '/') {
    //       this.routeDecider();
    //     }
    //   }
    // });
  }

  ngOnInit(): void {
    // this.routeDecider();
  }

  onLogout(e: any) {
    this.authService.logout();
  }

  routeDecider() {
    let authData = this.authService.authData;
    if (authData && authData.Features) {
      const features = authData.Features;
      const isAgent = location.pathname.toLocaleLowerCase().search(/agent/g) > -1;
      const isSupervisor = location.pathname.toLocaleLowerCase().search(/supervisor/g) > -1;
      const isAdmin = location.pathname.toLocaleLowerCase().search(/admin/g) > -1;
      if (!isAgent && !isAdmin && !isSupervisor) {
        this.authService.agentDefaultUrl();
        console.log('Routing to default page', Constants.Apps.Agent.defaultPath);
        this.router.navigate([Constants.Apps.Agent.defaultPath]);
      } else {
        this.router.navigate([location.pathname]);
      }
    }
  }
  onReload() {
    window.location.reload();
  }

  isRoot() {
    const isRoot = location.pathname.toLocaleLowerCase().search(/\//g) > -1;
    return isRoot;
  }

  isAuth() {
    const isAgent = location.pathname.toLocaleLowerCase().search(/agent/g) > -1;
    const isSupervisor = location.pathname.toLocaleLowerCase().search(/supervisor/g) > -1;
    const isAdmin = location.pathname.toLocaleLowerCase().search(/admin/g) > -1;
    const isRoot = location.pathname.toLocaleLowerCase().search(/\//g) > -1;
    return this.authService.authData && (isAdmin || isSupervisor || isAgent || isRoot);
  }
}
